/**
 * This solution is used to detect the mobile view in JS.
 * It's not ideal as it should be in CSS.
 * However refactoring all the header CSS layout
 * at this point in time is not advisable.
 * todo: Fixes were applied here to make this work without errors on SSR rendering on the BFF,
 * but the correct solution needs to be reviewed in the future.
 */
import { useEffect, useState } from 'react';

const mobileBreakpoint = 768; // Define your mobile breakpoint here

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < mobileBreakpoint;

const useMobileSizeDetect = (): boolean => {
  const [isMobileView, setIsMobileView] = useState(false); // Initialize with `false` to avoid SSR issues

  useEffect(() => {
    if (typeof window === 'undefined') return; // Ensure this runs only on the client

    const handleResize = () => setIsMobileView(isMobile());

    // Set the initial value on the client side
    setIsMobileView(isMobile());

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobileView;
};

export default useMobileSizeDetect;
